module.exports = __webpack_public_path__ + "img/15.756a32ec.png";